import { ApplicationInsights } from '@microsoft/applicationinsights-web';

let appInsights: ApplicationInsights | null = null;

export function initAppInsights(
  connectionString: string | undefined,
  deploymentEnv: string,
): ApplicationInsights | null {
  if (!connectionString || deploymentEnv === 'local') {
    return null;
  }

  appInsights = new ApplicationInsights({
    config: {
      connectionString,
      enableAutoRouteTracking: true,
      enableCorsCorrelation: true,
      enableRequestHeaderTracking: true,
      enableResponseHeaderTracking: true,
      disableFetchTracking: false,
      enableUnhandledPromiseRejectionTracking: true,
      isCookieUseDisabled: false,
      enableSessionStorageBuffer: true,
    },
  });

  appInsights.loadAppInsights();
  appInsights.context.application.ver = deploymentEnv;

  return appInsights;
}

export function getAppInsights(): ApplicationInsights | null {
  return appInsights;
}

export function trackException(error: Error): void {
  appInsights?.trackException({ exception: error });
}
